export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Reliable Supply',
      description: 'Direct access to verified manufacturers ensures consistent inventory for your business.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Stable Quality',
      description: 'All products undergo strict quality control to maintain stable and dependable standards.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Fast Delivery',
      description: 'Optimized warehouse and logistics processes help shorten delivery time.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Professional Service',
      description: 'Our service team provides efficient support for wholesale buyers around the world.'
    }
  ];

  return (
    <section className="w-full bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Your trusted partner for wholesale footwear solutions
          </p>
        </div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 bg-gray-50 rounded-lg hover:shadow-lg transition-shadow duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-5xl text-blue-600`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
